import { render } from "./CreateCustomerModal.vue?vue&type=template&id=75fae474&ts=true"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=ts"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__